var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-attendees"},_vm._l((_vm.list),function(user){return _c('Attendee',{key:user.id,attrs:{"user":user}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }